export default __webpack_public_path__ + "c156fe7713c7a18ff2d749c8e96b7120.png";